export const normalizeIdentifier = (text: string) => {
  return text
    .toLowerCase()
    .replaceAll("å", "a")
    .replaceAll("ä", "a")
    .replaceAll("ö", "o")
    .replace(/[^a-zA-Z0-9]+/g, "") // Remove chars not in a-Z or 0-9
    .trim()
}
